import React, { useState } from 'react';
import { FaHome, FaBox, FaTruck, FaCreditCard, FaFileAlt, FaCog } from "react-icons/fa";
import { IoLogOutSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { ApolloConsumer } from '@apollo/client';
import { toast } from 'react-toastify';
import { MdError } from 'react-icons/md';

const SideBar = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeItem, setActiveItem] = useState("Dashboard");
    const navigate = useNavigate();

    const menuItems = [
        { name: "Dashboard", icon: <FaHome size={17} />, href: "/dashboard" },
        { name: "Shipments", icon: <FaTruck size={17} />, href: "/dashshipment" },
        { name: "Orders", icon: <FaBox size={17} />, href: "/allorders" },
        { name: "NDR", icon: <MdError size={19} />, href: "/ndrdash" },
        { name: "Billing", icon: <FaCreditCard size={17} />, href: "/CodRemittances" },
        { name: "Escalations", icon: <FaFileAlt size={17} />, href: "/escalations" },
        { name: "Settings", icon: <FaCog size={17} />, href: "/settings" },
        { name: "Logout", icon: <IoLogOutSharp size={20} />, action: 'logout' },
    ];

    const handleLogout = (client) => {
        localStorage.clear();
        sessionStorage.clear();

        client.resetStore();

        toast.success("User logged out successfully!", {
            autoClose: 2000,
        });
        navigate('/signup');
    };

    return (
        <ApolloConsumer>
            {client => (
                <div
                    className={`fixed top-22 left-0 z-40 h-full bg-slate-800 text-white transition-all duration-300 ease-in-out overflow-y-auto
                    ${isSidebarOpen ? "w-64" : "w-16"}`}
                    onMouseEnter={() => setIsSidebarOpen(true)}
                    onMouseLeave={() => setIsSidebarOpen(false)}
                >
                    <nav className="mt-4 space-y-4 px-2">
                        {menuItems?.map((item) => (
                            <div
                                key={item?.name}
                                className={`flex items-center font-semibold space-x-3 p-3 rounded-md cursor-pointer hover:bg-slate-900
                                ${activeItem === item?.name ? "bg-slate-800" : ""}`}
                                onClick={() => {
                                    setActiveItem(item?.name);
                                    if (item?.action === 'logout') {
                                        handleLogout(client);
                                    } else {
                                        navigate(item?.href);
                                    }
                                }}
                            >
                                <span className="text-xl">{item?.icon}</span>
                                {isSidebarOpen && <span className="text-sm">{item?.name}</span>}
                            </div>
                        ))}
                    </nav>
                </div>
            )}
        </ApolloConsumer>
    );
};

export default SideBar;
